import React from 'react';
import { Gift, ArrowRight } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Guía PLC - Automatización desde cero',
    desc: 'Domina el cerebro de la industria moderna. Dejá de ser un electricista de cables para ser uno de "lógica".',
    value: '$67.00 USD'
  }, {
    num: '02',
    title: 'Manual de Instalaciones Eléctricas Domiciliarias PRO',
    desc: 'La base reglamentaria y de seguridad para que tus trabajos hogareños sean impecables y sin fallas.',
    value: '$37.00 USD'
  }, {
    num: '03',
    title: 'Manual de Tablerista Eléctrico de Élite',
    desc: 'Aprendé a montar tableros que parecen obras de arte. La prolijidad es lo que te permite cobrar el doble.',
    value: '$47.00 USD'
  }];
  return <section className="py-8 md:py-14 px-4 bg-brand-section border-y-2 border-gray-200" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <div className="text-center mb-6" data-id="element-20">
          <h2 className="text-lg md:text-2xl font-black text-brand-text leading-tight" data-id="element-21">
            Si ordenas hoy tu Guía de Comandos, te llevás estos{' '}
            <span className="text-brand-danger" data-id="element-22">3 manuales de alto valor</span>{' '}
            completamente GRATIS:
          </h2>
        </div>

        <div className="space-y-4 mb-6" data-id="element-23">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white rounded-xl p-4 md:p-6 border-2 border-brand-secondary shadow-md relative overflow-hidden flex flex-col md:flex-row items-center md:items-start gap-4" data-id="element-24">
              <div className="bg-brand-secondary text-brand-text font-black text-lg md:text-xl w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center shrink-0 shadow-md border-4 border-white" data-id="element-25">
                {bonus.num}
              </div>

              <div className="flex-1 text-center md:text-left" data-id="element-26">
                <div className="flex items-center justify-center md:justify-start gap-1.5 mb-1.5" data-id="element-27">
                  <Gift className="w-3.5 h-3.5 text-brand-danger" data-id="element-28" />
                  <span className="text-brand-danger font-black text-[10px] md:text-xs tracking-widest uppercase" data-id="element-29">
                    BONO {bonus.num}
                  </span>
                </div>
                <h3 className="text-sm md:text-lg font-black leading-tight text-brand-text mb-2" data-id="element-30">
                  {bonus.title}
                </h3>
                <p className="text-xs md:text-sm text-brand-steel font-medium mb-3 leading-snug" data-id="element-31">
                  {bonus.desc}
                </p>
                <div className="bg-brand-bg inline-block px-3 py-1.5 rounded-lg border border-gray-200" data-id="element-32">
                  <p className="text-[11px] md:text-xs text-brand-steel font-bold" data-id="element-33">
                    Valor normal:{' '}
                    <span className="line-through" data-id="element-34">{bonus.value}</span>{' '}
                    <ArrowRight className="inline w-3 h-3 mx-0.5 text-brand-danger" data-id="element-35" />{' '}
                    <span className="text-brand-danger font-black text-xs md:text-sm" data-id="element-36">
                      HOY: $0 (GRATIS)
                    </span>
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}